import React from 'react';
import PropTypes from 'prop-types';
import rtl from 'jss-rtl';
import { create } from 'jss';
import { JssProvider } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import { jssPreset, createGenerateClassName } from '@mui/styles';

import AppRoutes from './routes';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const generateClassName = createGenerateClassName();

const App = ({ themeConfig, layoutConfig }) => {
    const navigate = useNavigate();

    React.useEffect(() => {
        if (document.body) {
            document.body.dir = themeConfig.contentTheme.direction;
        }
    }, [themeConfig.contentTheme.direction]);

    const childProps = {};

    sessionStorage.setItem(
        'portalData',
        JSON.stringify({
            theme: {
                ...themeConfig,
            },
            layout: {
                ...layoutConfig,
            },
        }),
    );

    const materialTheme = createTheme(themeConfig.contentTheme);

    return (
        <JssProvider jss={jss} generateClassName={generateClassName}>
            <ThemeProvider theme={materialTheme}>
                <AppRoutes childProps={childProps} layout={layoutConfig} navigate={navigate} />
            </ThemeProvider>
        </JssProvider>
    );
};

function mapStateToProps(state) {
    return {
        themeConfig: state.theme,
        layoutConfig: state.layout,
    };
}

App.propTypes = {
    themeConfig: PropTypes.shape({
        contentTheme: PropTypes.shape({
            direction: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    layoutConfig: PropTypes.shape({}).isRequired,
};

export default compose(connect(mapStateToProps))(App);
